import { types } from '../types/types';

// Authentication with Reducer
export const authReducer = (state = {}, action ) => {

    switch ( action.type ) {
        case types.login:
            sessionStorage.setItem('userSelect',JSON.stringify(action.payload));

            return {
                ...action.payload,
                logged: true
            }

        case types.logout:
            //localStorage.removeItem("userToken");
            sessionStorage.removeItem('userSelect');
            return {
                logged: false
            }
    
        default:
            return state;
    }

}